import { render, staticRenderFns } from "./AddressTypeSelect.vue?vue&type=template&id=19afd62c&"
import script from "./AddressTypeSelect.vue?vue&type=script&lang=js&"
export * from "./AddressTypeSelect.vue?vue&type=script&lang=js&"
import style0 from "./AddressTypeSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports